module.exports = __webpack_public_path__ + "static/media/ico_arrow_up.a9d7e69e.svg";